import React from "react";
import { useTranslation } from "react-i18next";
import { MainHead } from "main/javascripts/components/head/MainHead";

export interface IProps {
  origin?: string;
  noindex?: boolean;
  title?: string;
  description?: string;
}

export const CruiseHead: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { t } = useTranslation(["constant"]);
  const { title, description, ...rest } = props;

  let metaTitle;
  if (title) {
    metaTitle = title;
  } else {
    metaTitle = t("seo.titleCruiseIndex");
  }

  return <MainHead title={metaTitle} description={description} {...rest} />;
};
